import { z } from "zod";
import { IdSchema, IsoDateTimeSchema, LocaleSchema } from "./common.js";
/**
 * Aviso dentro do jogo e relato de erro do jogo: o que o cliente lê e manda.
 *
 * O aviso vem já no idioma do jogador (`GET /notices?locale=`). O relato de
 * erro sobe sem sessão também, porque a tela que quebrou pode ser a de login.
 */
export const NoticeLevelSchema = z.enum(["info", "warning", "critical"]);
/** Texto nos três idiomas do jogo. */
export const LocalizedTextSchema = z
    .object({
    "pt-BR": z.string().trim().min(1).max(2_000),
    en: z.string().trim().min(1).max(2_000),
    es: z.string().trim().min(1).max(2_000),
})
    .strict();
export const NoticeSchema = z.object({
    id: IdSchema,
    level: NoticeLevelSchema,
    title: z.string(),
    body: z.string(),
    startsAt: IsoDateTimeSchema,
    endsAt: IsoDateTimeSchema,
});
export const NoticesQuerySchema = z.object({ locale: LocaleSchema.optional() }).strict();
export const NoticesResponseSchema = z.object({ items: z.array(NoticeSchema) });
// ---------------------------------------------------------------------------
// Erros do jogo
// ---------------------------------------------------------------------------
export const ClientErrorReportSchema = z
    .object({
    platform: z.enum(["web", "windows", "android", "ios", "unknown"]),
    appVersion: z.string().trim().min(1).max(32),
    message: z.string().trim().min(1).max(1_000),
    stack: z.string().max(20_000).optional(),
    /** Tela, ação, id da liga: o que ajudar a reproduzir. Nada de senha nem token. */
    context: z.record(z.unknown()).optional(),
})
    .strict();
//# sourceMappingURL=notices.js.map